import { Link, useHistory } from "react-router-dom";
import { Menu } from "antd";
import Sider from "antd/lib/layout/Sider";
import { useEffect, useState } from "react";

function AppMainSider(props) {
	const history = useHistory();
	const splitPath = window.location.pathname.split("/");
	const { siderItems } = props

	function getPathname(key) {
		return `/${key}`
	}

	function navigate(domElement, path) {
		domElement.preventDefault()
		history.push(path)
	}

	return (
		<Sider
			width="250"
			id="sider"
			theme="dark"
			ref={props.reference}
		// breakpoint="xl"
		// collapsedWidth="60" onCollapse={() => { setInlineCollapsed(!inlineCollapsed); }}
		>
			<Menu
				mode="inline"
				selectedKeys={[splitPath[1] === "forms" ? `forms/${splitPath[2]}` : splitPath[1]]}
				className="sider-menu"
				items={siderItems.map(item => {
					if (typeof item?.label === "string") {
						if (!item.children) {
							let path = getPathname(item?.key)
							item.label = <Link
								to={{ pathname: path }}
								onClick={(e) => navigate(e, path)}
							>
								{item.label}
							</Link>
						}
						else {
							item.children = item?.children?.map(subItem => {
								if (typeof subItem?.label === "string") {
									let path = getPathname(subItem.key)
									subItem.label = <Link
										to={{ pathname: path }}
										onClick={(e) => navigate(e, path)}
									>
										{subItem.label}
									</Link>
								}
								return subItem
							})
						}
					}
					return item
				})}
				// inlineCollapsed={inlineCollapsed}
				theme="dark"
			/>
		</Sider>
	);
}

export default AppMainSider;
